import React, { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Spin } from 'antd';
import TransactionDetails from '../../common/TransactionDetalis';
import {
  TRANSACTION_DETAILS_GS_QUERY,
  FRAUD_TRANSACTION_DETAILS_GS_QUERY
} from './constant';
import { TM_FRAUD_SOURCE_STRINGS } from '../../../util/GlobalConstant';

const USE_API_CONFIG = process.env.REACT_APP_TXN_CONFIG_SOURCE === 'api';

const TransactionDetailsTab = ({ settings, alertId, sourceId, ...props }) => {
  const [apiSettings, setApiSettings] = useState(null);
  const [isLoadingApiConfig, setIsLoadingApiConfig] = useState(false);

  // Fetch config from API if enabled
  useEffect(() => {
    if (!USE_API_CONFIG || !alertId) return;

    const fetchConfigFromApi = async () => {
      try {
        setIsLoadingApiConfig(true);
        // Determine which widget group to fetch based on module
        const widgetGroupId = props.module === 'CM_MANUAL_CUSTOMER_TRANSACTION_HISTORY'
          ? 'TM_IAD_TRANSACTION_DETAILS_GROUP'
          : 'TM_IAD_TRANSACTION_DETAILS_GROUP';

        const pageId = 'TM_IAD_ALERTS_DETAILS';

        // This would be an API call to fetch the config from backend
        // For now, we'll use the settings file by default and allow API override
        // The actual API integration depends on your backend endpoint
        const response = await fetch(
          `/api/ui/widgets/byPageAndGroupId?pageId=${pageId}&groupId=${widgetGroupId}`,
          {
            headers: {
              'Authorization': `Bearer ${localStorage.getItem('id_token')}`
            }
          }
        );

        if (response.ok) {
          const data = await response.json();
          // Transform API response to match settings.json structure
          const transformedSettings = {
            pageId,
            uiWidgetGroups: [{
              widgetGroupId,
              widgets: [{
                widgetId: 'TM_IAD_TRANSACTION_DETAILS_WIDGET',
                widgetConfig: data.widgets || []
              }]
            }]
          };
          setApiSettings(transformedSettings);
        }
      } catch (error) {
        // Fallback to settings file on error
        setApiSettings(null);
      } finally {
        setIsLoadingApiConfig(false);
      }
    };

    fetchConfigFromApi();
  }, [alertId, props.module, USE_API_CONFIG]);

  const effectiveSettings = useMemo(() => {
    if (USE_API_CONFIG && apiSettings) {
      return apiSettings;
    }
    return settings;
  }, [USE_API_CONFIG, apiSettings, settings]);

  if (isLoadingApiConfig) {
    return <Spin />;
  }

  return (
    <TransactionDetails
      settings={effectiveSettings}
      alertId={alertId}
      gsQuery={
        sourceId && sourceId === TM_FRAUD_SOURCE_STRINGS.FRAUDIAD
          ? FRAUD_TRANSACTION_DETAILS_GS_QUERY
          : TRANSACTION_DETAILS_GS_QUERY
      }
      {...props}
    />
  );
};

TransactionDetailsTab.propTypes = {
  settings: PropTypes.object,
  alertId: PropTypes.string.isRequired,
  sourceId: PropTypes.string,
  isFromCM: PropTypes.bool,
  module: PropTypes.string
};

export default TransactionDetailsTab;
